/*
  English captions for the store's own videos (WCAG 1.2.2).

  The captions live in video-captions.json, keyed by the Shopify file id that
  appears in each video's URL (…/videos/c/vp/<id>/<id>.HD-720p.mp4), and were
  made from the videos' soundtracks with the Captions App, then checked.
  Shopify's video_tag can't add a <track>, and the theme swaps videos in late
  (as they scroll into view or when Play is pressed), so this waits for a
  video to start loading and adds the track then.

  Captions are off until the visitor turns them on. Most of the theme's videos
  have no player controls, so those get a "CC" button beside the pause button;
  a video with the browser's own controls already has a captions toggle there.
  The visitor's choice is remembered and applies to every video. Until they
  make one, the browser decides: Safari, for instance, shows captions straight
  away for someone who has asked their device to always show them.
*/
(function () {
  var script = document.currentScript;
  var url = script && script.dataset.captions;
  if (!url) return;
  var data = null;   // the JSON, once fetched (only when a captioned video loads)
  var pending = null;
  var ID = /\/videos\/c\/(?:vp|o\/v)\/([0-9a-f]{32})\//;
  var KEY = 'video-captions';   // 'on' | 'off', once the visitor has chosen
  var tracks = [];              // every caption track added on this page

  function choice() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* storage unavailable: this page only */ } }

  var style = document.createElement('style');
  style.textContent =
    '.video-cc{position:absolute;inset-inline-end:12px;inset-block-end:12px;z-index:5;' +
    'display:flex;align-items:center;justify-content:center;min-width:40px;height:40px;padding:0 10px;' +
    'border:0;border-radius:999px;background:rgba(18,30,42,.72);color:#fff;cursor:pointer;' +
    'font:700 13px/1 system-ui,-apple-system,"Segoe UI",sans-serif;letter-spacing:.04em}' +
    '.video-cc:hover{background:rgba(18,30,42,.9)}' +
    '.video-cc[aria-pressed="false"] span{opacity:.75;text-decoration:line-through;text-decoration-thickness:2px}' +
    '.video-cc:focus-visible{outline:2px solid #fff;outline-offset:2px;box-shadow:0 0 0 4px rgba(18,30,42,.9)}' +
    '.video-cc.beside-pause{inset-inline-end:60px}';
  document.head.appendChild(style);

  function load() {
    if (!pending) {
      pending = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (j) { data = j || {}; return data; })
        .catch(function () { data = {}; return data; });
    }
    return pending;
  }

  function idOf(v) {
    var srcs = [v.currentSrc, v.getAttribute('src')];
    var s = v.querySelectorAll('source');
    for (var i = 0; i < s.length; i++) srcs.push(s[i].src);
    for (var j = 0; j < srcs.length; j++) {
      var m = srcs[j] && ID.exec(srcs[j]);
      if (m) return m[1];
    }
    return null;
  }

  // Same place as the pause button (video-pause.js): outside any link the
  // video sits in, so the button isn't nested inside it.
  function hostFor(v) {
    var host = v.closest('.media') || v.parentElement;
    var link = host && host.closest('a');
    if (link) host = link.parentElement;
    if (host && getComputedStyle(host).position === 'static') host.style.position = 'relative';
    return host;
  }

  function showing() {
    for (var i = 0; i < tracks.length; i++) if (tracks[i].track.mode === 'showing') return true;
    return false;
  }

  // Every button on the page tells the truth about the captions.
  function syncButtons() {
    var on = showing();
    var btns = document.querySelectorAll('.video-cc');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[i].setAttribute('aria-label', on ? 'Turn captions off' : 'Turn captions on');
    }
  }

  function setAll(on) {
    for (var i = 0; i < tracks.length; i++) tracks[i].track.mode = on ? 'showing' : 'hidden';
    syncButtons();
  }

  function button(v) {
    if (v.controls) return;   // the browser's controls have their own captions toggle
    var host = hostFor(v);
    if (!host) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-cc';
    btn.innerHTML = '<span aria-hidden="true">CC</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var on = !showing();
      remember(on ? 'on' : 'off');
      setAll(on);
    });
    host.appendChild(btn);
    syncButtons();
    // Beside the pause button, which arrives once the video starts playing.
    var place = function () { btn.classList.toggle('beside-pause', !!host.querySelector('.video-pause')); };
    place();
    v.addEventListener('play', function () { setTimeout(place, 0); });
  }

  function attach(v, entry) {
    if (v.dataset.captioned) return;
    v.dataset.captioned = '1';
    var track = document.createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    track.src = URL.createObjectURL(new Blob([entry.vtt], { type: 'text/vtt' }));
    v.appendChild(track);
    tracks.push(track);
    // The visitor's choice, once they've made one; until then the browser's.
    var apply = function () {
      var c = choice();
      if (c) track.track.mode = c === 'on' ? 'showing' : 'hidden';
      syncButtons();
    };
    apply();
    track.addEventListener('load', apply);
    // The browser's own captions toggle (on videos with controls) counts as a choice too.
    v.textTracks.addEventListener('change', function () {
      if (track.track.mode === 'showing' && choice() !== 'on') remember('on');
      else if (track.track.mode !== 'showing' && choice() === 'on' && v.controls) remember('off');
      syncButtons();
    });
    button(v);
  }

  function check(v) {
    if (!(v instanceof HTMLVideoElement) || v.dataset.captioned) return;
    var id = idOf(v);
    if (!id) return;
    if (data) { if (data[id]) attach(v, data[id]); return; }
    load().then(function (d) { if (d[id]) attach(v, d[id]); });
  }

  // Media events don't bubble, but they do pass through the document on the
  // way down, so one capturing listener sees every video on the page.
  document.addEventListener('loadstart', function (e) { check(e.target); }, true);
  document.addEventListener('play', function (e) { check(e.target); }, true);

  function scan() {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) check(vids[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
